import React from "react";

export class TrajanjePromocije extends React.Component {


    constructor(props) {
        super(props);
        this.state = { dana: '-', sati: '-', minuta: '-', sekundi: '-' }

        this.calculate = this.calculate.bind(this);
    }



    componentDidMount() {
        this.calculate();
        this.interval = setInterval(this.calculate, 1000);
    }
    componentWillUnmount() {
        clearInterval(this.interval);
    }
    calculate() {
        var podaci = { dana: '00', sati: '00', minuta: '00', sekundi: '00' };
        var krajPromocije = this.props && this.props.krajPromocije ? this.props.krajPromocije : null;
        var pocetakPromocije = this.props && this.props.pocetakPromocije ? this.props.pocetakPromocije : null;

        if (pocetakPromocije > new Date()) {
            var delta = (pocetakPromocije - new Date()) / 1000;
            var dana = Math.floor(delta / 86400);
            delta -= dana * 86400;
            var sati = Math.floor(delta / 3600) % 24;
            delta -= sati * 3600;
            var minute = Math.floor(delta / 60) % 60;
            delta -= minute * 60;
            var sekunde = Math.floor(delta % 60);

            podaci.dana = ('0' + dana).slice(-2);
            podaci.sati = ('0' + sati).slice(-2);
            podaci.minuta = ('0' + minute).slice(-2);
            podaci.sekundi = ('0' + sekunde).slice(-2);
        } else if (krajPromocije > new Date()) {
            var delta = (krajPromocije - new Date()) / 1000;
            var dana = Math.floor(delta / 86400);
            delta -= dana * 86400;
            var sati = Math.floor(delta / 3600) % 24;
            delta -= sati * 3600;
            var minute = Math.floor(delta / 60) % 60;
            delta -= minute * 60;
            var sekunde = Math.floor(delta % 60);

            podaci.dana = ('0' + dana).slice(-2);
            podaci.sati = ('0' + sati).slice(-2);
            podaci.minuta = ('0' + minute).slice(-2);
            podaci.sekundi = ('0' + sekunde).slice(-2);

        }
        else {
            clearInterval(this.interval);
        }
        this.setState(podaci);
    }

    render() {
        var pocetakPromocije = this.props && this.props.pocetakPromocije ? this.props.pocetakPromocije : null;

        if (pocetakPromocije > new Date()) {
            return <div className={'info-trajanje ' + (this.props.extraClass || '')}>
                <div className="margin-top-small mobile-hidden"><br /></div>
                <span className='info-trajanje--header'>Promocija počinje za</span>
                {/* <br />
                <span className='info-trajanje--header'>31. listopada 2018. u 12:00 sati</span> */}
                <div className='info-trajanje--countdown'>
                    <div className='info-trajanje--countdown--item as-inline-block'><div>{this.state.dana}</div><div>Dana</div></div>
                    <div className='info-trajanje--countdown--item as-inline-block'><div>{this.state.sati}</div><div>Sati</div></div>
                    <div className='info-trajanje--countdown--item as-inline-block'><div>{this.state.minuta}</div><div>Min</div></div>
                    <div className='info-trajanje--countdown--item as-inline-block'><div>{this.state.sekundi}</div><div>Sek</div></div>
                </div>
            </div>

        }

        return <div className={'info-trajanje ' + (this.props.extraClass || '')}>
            <div className="mobile-hidden ">&nbsp;<br /></div>
            <span className='info-trajanje--header'>Trajanje promocije</span>
            <div className='info-trajanje--countdown'>
                <div className='info-trajanje--countdown--item as-inline-block'><div>{this.state.dana}</div><div>Dana</div></div>
                <div className='info-trajanje--countdown--item as-inline-block'><div>{this.state.sati}</div><div>Sati</div></div>
                <div className='info-trajanje--countdown--item as-inline-block'><div>{this.state.minuta}</div><div>Min</div></div>
                <div className='info-trajanje--countdown--item as-inline-block'><div>{this.state.sekundi}</div><div>Sek</div></div>
            </div>
        </div>

    }
};

